import { filterOutIds } from './column-utils';
import { columns as driverAlertColumns } from './driver-alert-columns';
import { EXCEPTIONS_COLUMN_IDS } from '../../../consts';
import type { ColumnWithStrictId } from './column-utils';
import type { ElasticAlert, TranslatableOption } from '../../../types/common.consts';

const onlyDriverColumnIds = new Set(['data_user_name', EXCEPTIONS_COLUMN_IDS.USER_ID]);

// TODO: review ElasticAlert here, as Alert domain object type is passed as rows
export const columns: ColumnWithStrictId<ElasticAlert>[] = driverAlertColumns.filter(
	({ id }) => !onlyDriverColumnIds.has(id)
);

export const defaultOrderedColumnOptions: TranslatableOption[] = columns
	.filter(({ id }) => !filterOutIds.has(id))
	.map(({ id, translateKey }) => ({ id, translateKey }));

export const optimizationAlertColumnsTranslateKeys = columns.reduce((acc, column) => {
	acc.set(column.id, column.translateKey);
	return acc;
}, new Map());
